<template>
  <b-form id="advertiser_submit" @submit="onSubmit">
    <div class="row">
      <div class="col-sm-12">
        <b-form-group label="Официальное название"
                      label-for="legal_title">

          <b-form-input id="legal_title"
                        type="text"
                        v-model="form.legal_title">
          </b-form-input>
          <small class="form-text text-muted" v-if="$currentUser.department == 'adkey'">Название рекламодателя (ЮЛ клиента) можно взять в таблице "<a href="https://zorkamobi.sharepoint.com/:x:/s/BlackHat/ET3Gf3QjNb5IlTbK2BdP0AoBqzNIDQ3A64H_UVpxZ87M8A?e=Da49DG" target="_blank">Статус по офферам</a>".</small>
          <span class="alert-danger" v-for="error in formErrors.legal_title">{{ error }}</span>
        </b-form-group>

        <b-form-group label="Псевдоним"
                      label-for="title">
          <b-form-input id="title"
                        type="text"
                        v-model="form.title">
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Сейлз Менеджер"
          label-for="sales_manager">
          <v-select
            id="sales_manager"
            label="name"
            :options="salesManagers"
            :reduce="manager => manager.id"
            :selectable="(manager) => manager.selectable"
            required
            multiple
            v-model="form.sales_managers">
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
          <span class="alert-danger" v-for="error in formErrors.sales_managers">{{ formErrors.sales_managers }}</span>
        </b-form-group>

        <b-form-group
          label="Аккаунт Менеджер"
          label-for="account_manager">
          <v-select
            id="account_manager"
            label="name"
            :options="accountManagers"
            :reduce="accountManager => accountManager.id"
            :selectable="(manager) => manager.selectable"
            required
            v-model="form.account_manager_id"
            @input="clearDate">
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
          <span class="alert-danger" v-for="error in formErrors.account_manager_id">{{ formErrors.account_manager_id }}</span>
        </b-form-group>

        <b-form-group label="Канал продаж" v-if="this.$currentUser.department === 'adkey'">
          <v-select :options="channels"
                    :reduce="channel => channel.value"
                    required
                    :searchable="false"
                    v-model="form.channel">
          </v-select>
          <span class="alert-danger" v-for="error in formErrors.channel">Укажите канал продаж.</span>
        </b-form-group>

        <b-form-group label="Дата изменения Аккаунт Менеджера"
                      label-for="title">
          <datepicker input-class="form-control"
                      class="date"
                      :language="ru"
                      v-model="form.account_manager_change_date"
                      placeholder=""></datepicker>
          <span class="alert-danger" v-if="formErrors.account_manager_change_date">{{ formErrors.account_manager_change_date }}</span>
        </b-form-group>

        <b-button type="submit" class="float-right"
                  variant="primary">Сохранить и выйти
        </b-button>
      </div>
    </div>

    <div class="form-errors"></div>
  </b-form>
</template>

<script>
import advertisersService from "../../../services/advertisersDataService";
import advertiserMixin from "../mixins/Advertiser/createUpdateMixin";
import Datepicker from 'vuejs-datepicker'
import {ru} from '../../../services/customLocaleDatepicker'

export default {
  name: "EditAdvertiserModal",
  mixins: [advertiserMixin],
  props: {
    advertiser: Object,
  },
    components: {
        Datepicker: Datepicker
    },
  data() {
    return {
      form: {
        legal_title: this.advertiser.legal_title,
        title: this.advertiser.title,
        sales_managers: this.advertiser.sales_managers,
        account_manager_id: this.advertiser.new_account_manager_id,
        channel: this.advertiser.channel,
          account_manager_change_date: this.advertiser.account_manager_change_date,
      },
        ru: ru,
      channels: [
        {
          label: 'Конференция',
          value: 'conference'
        },
        {
          label: 'Нетворкинг',
          value: 'networking'
        },
        {
          label: 'Рекомендация',
          value: 'recommendation'
        },
        {
          label: 'Холодные продажи',
          value: 'coldsale'
        },
        {
          label: 'Запрос через сайт/соц.сети',
          value: 'website'
        }
      ],
    }
  },
  methods: {
    sendForm() {
      return advertisersService.updateAdvertiser(this.advertiser.id, this.form)
    },
      clearDate(event) {
          this.form.account_manager_change_date = null
      },

    async getAccountsManagers() {
      await this.getActiveAccountManagers()
      if (this.form.account_manager_id !== null && !this.accountManagers.find(manager => manager.id === this.form.account_manager_id)) {
        this.accountManagers.push({
          name: this.advertiser.account_manager.name,
          id: this.form.account_manager_id,
          selectable: false,
        })
      }
    },

    async getSalesManagers(){
      await this.getActiveSalesManagers()

      if (this.form.sales_managers !== null) {
          this.form.sales_managers.forEach(function (salesManager) {
              if (!this.salesManagers.find(manager => manager.id === salesManager.id)) {
                  this.salesManagers.push({
                      name: salesManager.name,
                      id: salesManager.id,
                      selectable: false,
                  })
              }
          }.bind(this))
      }
    }
  },

  mounted() {
    this.getAccountsManagers()
    this.getSalesManagers();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/views/front/modals/EditAdvertiserModal.vue